var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"country-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.query),expression:"query"}],staticClass:"input-element",attrs:{"type":"text","maxlength":"25"},domProps:{"value":(_vm.query)},on:{"input":[function($event){if($event.target.composing)return;_vm.query=$event.target.value},_vm.inputHander]}})])
}
var staticRenderFns = []

export { render, staticRenderFns }